<template>
  <div class="main-view">
    <Toolbar
      :title="$route.name"
      iconType="menu"
      @onClickLeftIcon="onClickLeftIcon"/>
    <transition name="slide">
      <ul class="menu" v-show="isMenuExpaned">
        <li v-if="isHouseOwner && !isAdmin"><router-link to="/role-list" @click="isMenuExpaned=false">角色列表</router-link></li>
        <li v-if="isHouseOwner && !isAdmin"><router-link to="/user-list" @click="isMenuExpaned=false">人員列表</router-link></li>
        <li v-if="isAdmin">
          <router-link
          v-on:click.native="isMenuExpaned = false"
          to="/door-status-list">門鎖控制狀態</router-link>
        </li>
        <li v-if="isAdmin">
          <router-link
          v-on:click.native="isMenuExpaned = false"
          to="/access-control-list">門禁系統管理</router-link>
        </li>
        <li v-if="isAdmin">
          <router-link
          v-on:click.native="isMenuExpaned = false"
          to="/role-list">角色列表</router-link>
        </li>
        <li v-if="isAdmin">
          <router-link
          v-on:click.native="isMenuExpaned = false"
          to="/user-list">人員列表</router-link>
        </li>
        <li v-if="isAdmin">
          <router-link
          v-on:click.native="isMenuExpaned = false"
          to="/mail-system">信箱管理系統</router-link>
        </li>
        <li v-if="isAdmin">
          <a
            target="_blank"
            rel="noopener noreferrer"
            :href="lockerSystemUrl"
            @click="isMenuExpaned = false">智能櫃系統</a>
        </li>
        <li v-if="isAdmin">
          <router-link
          v-on:click.native="isMenuExpaned = false"
          to="/public-facility-booking">公設預約查詢</router-link>
        </li>
        <li v-if="isAdmin">
          <router-link
          v-on:click.native="isMenuExpaned = false"
          to="/intercom-engineering">工程門口機撥號</router-link>
        </li>
        <li v-if="isAdmin">
          <router-link
          v-on:click.native="isMenuExpaned = false"
          to="/intercom-devices">對講裝置管理</router-link>
        </li>
        <li>
          <router-link
          v-on:click.native="logout"
          to="/login">登出</router-link>
        </li>
      </ul>
    </transition>
    <router-view/>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import Toolbar from '@/components/Toolbar.vue'
import runtimeConfig from '@/config/runtime'

export default defineComponent({
  name: 'Login',
  components: {
    Toolbar
  },
  data: function () {
    return {
      isMenuExpaned: false,
      lockerSystemUrl: runtimeConfig.lockerPortalUrl,
	  isAdmin: window.localStorage.getItem('is_admin') === 'true',
      isHouseOwner: window.localStorage.getItem('is_house_owner') === 'true'
    }
  },
  methods: {
    onClickLeftIcon () {
      this.isMenuExpaned = !this.isMenuExpaned
    },
    toggle (e: Event) {
      const target = e.target as HTMLElement
      target.parentElement?.querySelector('.nested')?.classList.toggle('active')
    },
    alertTodo (text: string) {
      alert(`TODO: ${text}`)
    },
    logout () {
      this.isMenuExpaned = false
      window.localStorage.removeItem('access_token')
	  window.localStorage.removeItem('is_admin')
	  window.localStorage.removeItem('is_house_owner')
    }
  }
})
</script>

<style scoped lang="scss">
  .main-view {
    width: 100vw;
    min-height: calc(100vh - 54px);
    padding-top: 54px;
  }
  .menu {
    width: 300px;
    height: calc(100% - 64px);
    overflow-y: scroll;
    background: white;
    position: absolute;
    user-select: none;
    z-index: 10;
    a, span {
      height: 48px;
      display: flex;
      align-items: center;
      font-size: 18px;
      letter-spacing: 1.13px;
      color: #191919;
      text-decoration: none;
      cursor: pointer;
    }
  }
  ul {
    list-style-type: none;
    padding: 0px;
    margin: 0px;
    a, span {
      padding-left: 40px;
    }
    > li > ul {
      background-color: rgba(222, 204, 142, 0.3);
      a, span {
        padding-left: 54px;
      }
    }
  }
  .slide-enter-active {
    transition: transform .2s ease-in-out;
  }
  .slide-leave-active {
    transition: transform .2s ease-in-out;
  }
  .slide-enter, .slide-leave-to {
    transform: translateX(-300px);
  }
  .slide-enter-to, .slide-leave {
    transform: translateX(0);
  }
  .nested {
    display: block;
    overflow: hidden;
    max-height: 0px;
    transition: max-height .2s ease-in-out;
  }
  .active {
    max-height: 144px;
    transition: max-height .1s ease-in-out;
  }
</style>
